import { Search, X } from "lucide-react";
import { Input } from "../ui/input";
import { Field, SelectField, inputCls } from "../landing/Field";
import { LocationPicker } from "../landing/LocationPicker";
import { RolePicker } from "../landing/RolePicker";

export const LeadFilters = ({ config, filters, setFilters, onReset }) => {
  const set = (k) => (v) => setFilters((p) => ({ ...p, [k]: v }));
  return (
    <div data-testid="admin-filters" className="grid grid-cols-1 gap-4 border border-white/10 bg-[#0F172A] p-5 sm:grid-cols-2 lg:grid-cols-4">
      <Field label="Search">
        <div className="relative">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <Input data-testid="admin-filter-search" className={`${inputCls} pl-9`} value={filters.q || ""}
            onChange={(e) => set("q")(e.target.value)} placeholder="Name, phone, reference..." />
        </div>
      </Field>
      <LocationPicker prefix="admin-filter" state={filters.state || ""} district={filters.district || ""}
        onChange={(s, d) => setFilters((p) => ({ ...p, state: s, district: d }))} />
      <RolePicker prefix="admin-filter" department={filters.department || ""} jobRole={filters.job_role || ""}
        onChange={(d, r) => setFilters((p) => ({ ...p, department: d, job_role: r }))} />
      {config.filters.map((f) => (
        <SelectField key={f.key} label={f.label} value={filters[f.key] || ""} onChange={set(f.key)} options={f.options}
          placeholder="All" testId={`admin-filter-${f.key.replace(/_/g, "-")}`} />
      ))}
      <Field label="From date">
        <Input type="date" data-testid="admin-filter-date-from" className={`${inputCls} [color-scheme:dark]`} value={filters.date_from || ""}
          onChange={(e) => set("date_from")(e.target.value)} />
      </Field>
      <Field label="To date">
        <Input type="date" data-testid="admin-filter-date-to" className={`${inputCls} [color-scheme:dark]`} value={filters.date_to || ""}
          onChange={(e) => set("date_to")(e.target.value)} />
      </Field>
      <div className="flex items-end">
        <button type="button" onClick={onReset} data-testid="admin-filter-reset"
          className="flex h-11 items-center gap-2 border border-white/15 px-4 text-sm text-slate-300 transition-colors hover:border-orange-500 hover:text-white">
          <X className="h-4 w-4" />Clear filters
        </button>
      </div>
    </div>
  );
};
